import ADND from '../ADND'
import { requestAnimationFrame, getScrollX, getScrollY, DATA_ITEM_TYPE_PREFIX } from '../ADNDHelpers'
import { updateState } from '../ADNDState'

export const TEXT_TYPE = 'Text'
export const JSON_TYPE = 'application/json'

export const TRANSPARENT_1X1_PNG =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='

export function DEFAULT_PROPS() {
  return {
    node: null,
    rect: null,
    type: null,
    data: null,
    dataFetcher: null,
    onStartHandler: null,
    acceptDragFetcher: null,
    onEndHandler: null,
    crossTab: true,
    clearDragImage: true,
    edgeScrolling: true
  }
}

export const CONNECT = {
  dragStart(event) {
    if (null != this.props.type) {
      const data = this.PRIVATE.fetchData()
      if (null != data) {
        this.props.data = data

        // update state
        const source = this
        updateState(function (state) {
          source.PRIVATE.fetchRect()
          if (null != source.props.rect) {
            state.item.width = source.props.rect.width
            state.item.height = source.props.rect.height
          }
          state.source = source
          if (null == state.layers) {
            state.layers = {}
          }
          state.layers.edgeScrolling = source.props.edgeScrolling
          return state
        })

        if (event.dataTransfer) {
          event.dataTransfer.setData(TEXT_TYPE, '')
          // set crosstab data
          if (this.props.crossTab) {
            // set json type (IE/Edge fill fuck it)
            try {
              const jsonData = JSON.stringify(data)
              event.dataTransfer.setData(JSON_TYPE, jsonData)
            } catch {
              //
            }

            // set item type (IE/Edge will fuck it)
            try {
              event.dataTransfer.setData(`${DATA_ITEM_TYPE_PREFIX}${this.props.type}`, 'true')
            } catch {
              //
            }
          }

          // clear drag image
          if (this.props.clearDragImage) {
            if (event.dataTransfer.setDragImage) {
              try {
                const transparentImage = document.createElement('img')
                transparentImage.src = TRANSPARENT_1X1_PNG
                event.dataTransfer.setDragImage(transparentImage, 0, 0)
              } catch {
                //
              }
            } else {
              const target = event.srcElement || event.target
              const transparentDragSource = target.cloneNode(true)
              transparentDragSource.innerHTML = ''
              transparentDragSource.style.border = 'none'
              transparentDragSource.style.padding = '0'
              transparentDragSource.style.width = '1px'
              transparentDragSource.style.height = '1px'
              target.parentNode.insertBefore(transparentDragSource, target)
              target.parentNode.removeChild(target)
              requestAnimationFrame(function () {
                transparentDragSource.parentNode.insertBefore(target, transparentDragSource)
                transparentDragSource.remove()
              })
            }
          }
        }

        // blur focused element
        if (
          document.activeElement &&
          document.activeElement != document.body &&
          'function' == typeof document.activeElement.blur
        ) {
          document.activeElement.blur()
        }

        this.PRIVATE.doStart(event)
      } else {
        event.preventDefault()
      }
    } else {
      event.preventDefault()
    }
  },
  dragEnd(event) {
    this.PRIVATE.doEnd(event)
    ADND().stop(event)
    const source = this
    updateState(function (state) {
      if (state.source === source) {
        state.source = null
      }
      return state
    })
  }
}

export const PRIVATE = {
  acceptDrag() {
    return this.props.acceptDragFetcher ? this.props.acceptDragFetcher(this.PUBLIC) : true
  },
  fetchData() {
    return this.props.dataFetcher ? this.props.dataFetcher() : null
  },
  doStart(event) {
    if (this.props.onStartHandler) {
      this.props.onStartHandler(event, this.PUBLIC)
    }
    return this.PRIVATE
  },
  doEnd(event) {
    if (this.props.onEndHandler) {
      this.props.onEndHandler(event, this.PUBLIC)
    }
    return this.PRIVATE
  },
  fetchRect(scrollX = getScrollX(), scrollY = getScrollY()) {
    if (null != this.props.node) {
      const rect = this.props.node.getBoundingClientRect()
      this.props.rect = {
        left: rect.left + scrollX,
        right: rect.right + scrollX,
        top: rect.top + scrollY,
        bottom: rect.bottom + scrollY,
        width: rect.width || rect.right - rect.left,
        height: rect.height || rect.bottom - rect.top
      }
    } else {
      this.props.rect = null
    }
    return this.PRIVATE
  }
}

export const PUBLIC = {
  connect(node) {
    if (node != this.props.node) {
      if (null != this.props.node) {
        this.PUBLIC.disconnect()
      }
      if (null != node) {
        node.addEventListener('dragstart', this.CONNECT.dragStart, true)
        node.addEventListener('dragend', this.CONNECT.dragEnd, true)
        node.draggable = true
      }
      this.props.node = node
    }
    return this.PUBLIC
  },
  disconnect() {
    if (null != this.props.node) {
      this.props.node.removeEventListener('dragstart', this.CONNECT.dragStart, true)
      this.props.node.removeEventListener('dragend', this.CONNECT.dragEnd, true)
      this.props.node.draggable = false
      this.props.node = null
    }
    return this.PUBLIC
  },
  connectedNode() {
    return this.props.node
  },
  onStart(onStartHandler) {
    if ('function' == typeof onStartHandler) {
      this.props.onStartHandler = onStartHandler
    }
    return this.PUBLIC
  },
  acceptDrag(acceptDragFetcher) {
    if ('function' == typeof acceptDragFetcher) {
      this.props.acceptDragFetcher = acceptDragFetcher
    }
    return this.PUBLIC
  },
  onEnd(onEndHandler) {
    if ('function' == typeof onEndHandler) {
      this.props.onEndHandler = onEndHandler
    }
    return this.PUBLIC
  },
  fetchData(dataFetcher) {
    if ('function' == typeof dataFetcher) {
      this.props.dataFetcher = dataFetcher
    }
    return this.PUBLIC
  },
  getType() {
    return this.props.type
  },
  getData() {
    return this.props.data
  }
}

export function extendADNDDataSource(props = {}, defaultProps = DEFAULT_PROPS()) {
  const ADNDDataSource = {
    props: Object.assign({}, defaultProps, props)
  }

  ADNDDataSource.CONNECT = {
    dragStart: CONNECT.dragStart.bind(ADNDDataSource),
    dragEnd: CONNECT.dragEnd.bind(ADNDDataSource)
  }

  ADNDDataSource.PRIVATE = {
    acceptDrag: PRIVATE.acceptDrag.bind(ADNDDataSource),
    fetchData: PRIVATE.fetchData.bind(ADNDDataSource),
    doStart: PRIVATE.doStart.bind(ADNDDataSource),
    doEnd: PRIVATE.doEnd.bind(ADNDDataSource),
    fetchRect: PRIVATE.fetchRect.bind(ADNDDataSource)
  }

  ADNDDataSource.PUBLIC = {
    connect: PUBLIC.connect.bind(ADNDDataSource),
    disconnect: PUBLIC.disconnect.bind(ADNDDataSource),
    connectedNode: PUBLIC.connectedNode.bind(ADNDDataSource),
    onStart: PUBLIC.onStart.bind(ADNDDataSource),
    acceptDrag: PUBLIC.acceptDrag.bind(ADNDDataSource),
    onEnd: PUBLIC.onEnd.bind(ADNDDataSource),
    fetchData: PUBLIC.fetchData.bind(ADNDDataSource),
    getType: PUBLIC.getType.bind(ADNDDataSource),
    getData: PUBLIC.getData.bind(ADNDDataSource)
  }

  return ADNDDataSource
}

export default function ADNDDataSource(props) {
  return extendADNDDataSource(props).PUBLIC
}

ADNDDataSource.TEXT_TYPE = TEXT_TYPE
ADNDDataSource.JSON_TYPE = JSON_TYPE
ADNDDataSource.DATA_ITEM_TYPE_PREFIX = DATA_ITEM_TYPE_PREFIX
